// 2023.11.20.
// [MiMi]
// dev server
// let baseURL = "http://adamohomepage.sh7.wp-office";

// for production
let baseURL = "https://adamo-platform.com";


export async function fetchAdamo(relativeURL, httpMethodString, payloadObject={}) {
    let url = baseURL + relativeURL;

    let response = null;
    console.log("Fetching backend on "+relativeURL);
    
    if (httpMethodString.toUpperCase() === "GET") { // GET request cannot have a body.
        console.log("Sending GET request...");
        response = await fetch(url, {
            method: httpMethodString,
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
            }
        })

    } 
    else if (httpMethodString.toUpperCase() === "POST") {
        console.log("Sending POST request with payload:")
        console.log(payloadObject);
        response = await fetch(url, {
            method: httpMethodString,
            mode: "cors",
            // turn on for production server
            // turn off for dev
            headers: {
                "Content-Type": "application/json",
            },
            // until this line
            body: JSON.stringify(payloadObject)
        })
    }

    return response;
};
